const items = {
  title: 'Calendário',
  description: 'Nesta seção é possível visualizar por mês todos os serviços e não-conformidades geradas',

  title1: 'Ações Geradas',
  description1: 'Ações Geradas ou Não-conformidades geradas em formato de lista para consulta',

  title2: 'Locais',
  description2: 'Navegue por todos os locais e setores da sua empresa, selecionando algum destes locais, é possível visualizar os equipamentos',

  title3: 'Mapa',
  description3: 'Visualize através do Google Maps os equipamentos e locais',

  title4: 'Dashboard',
  description4: 'Dashboard com várias análises e filtros',

  title5: 'Equipamentos',
  description5: 'Lista de todos os equipamentos cadastrados',

  title6: 'Serviços Realizados',
  description6: 'Lista com todos os serviços realizados',

  title7: 'Empresas Terceiras',
  description7: 'Empresas terceiras cadastradas',
}

export default items;
